import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  login as loginAction,
  logout as logoutAction,
  selectAuthError,
  selectAuthLoading,
  selectIsAuthenticated,
  selectUser,
} from "../redux/authReducer";

export const useAuth = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);

  const login = useCallback(
    async (email, password) => {
      try {
        const result = await dispatch(
          loginAction({ email, password })
        ).unwrap();
        return { success: true, user: result };
      } catch (err) {
        return { success: false, error: err };
      }
    },
    [dispatch]
  );

  const logout = useCallback(async () => {
    await dispatch(logoutAction());
  }, [dispatch]);

  const hasRole = useCallback(
    (role) => {
      if (!user) return false;
      return user.role === role;
    },
    [user]
  );

  const isPanelAdmin = useCallback(
    (panelId = null) => {
      if (!user) return false;
      if (!user.isPanelAdmin) return false;
      if (panelId) {
        return user.adminForPanels?.includes(panelId);
      }
      return true;
    },
    [user]
  );

  return {
    user,
    login,
    logout,
    loading,
    error,
    hasRole,
    isPanelAdmin,
    isAuthenticated,
  };
};

export default useAuth;
